import { useEffect, useState } from 'react';

/** Minutes since local midnight, the unit every time in a session uses. */
export const nowMinutes = (): number => {
  const d = new Date();
  return d.getHours() * 60 + d.getMinutes();
};

/**
 * The wall clock, as a ticking value.
 *
 * Reading `new Date()` during render gives a clock that only moves when
 * something else happens to re-render -- fine for a static view, useless for
 * "who is on this mic right now" during a show. This ticks on the minute
 * boundary so the board changes over at the same moment the schedule says it
 * does, rather than up to a minute late.
 */
export function useNowMinutes(): number {
  const [min, setMin] = useState(nowMinutes);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const schedule = () => {
      const d = new Date();
      const msToNextMinute = (60 - d.getSeconds()) * 1000 - d.getMilliseconds();
      timer = setTimeout(() => {
        setMin(nowMinutes());
        schedule();
      }, msToNextMinute);
    };
    schedule();
    return () => clearTimeout(timer);
  }, []);

  return min;
}
